<template>
   <v-card tile>
    <v-toolbar card dark color="orange">
      <v-btn icon @click.native="$emit('close')" dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Busca de Parente</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-items>
        <v-btn dark flat @click.native="dialog_criterios = true">Adicionar Critério</v-btn>
        <v-btn dark flat @click.native="avaliar()">Salvar Avaliação</v-btn>
        <v-btn dark flat @click.native="avaliarepublicar()">Salvar e Publicar</v-btn>
      </v-toolbar-items> -->
    </v-toolbar>
      <v-layout row wrap>
        <v-flex>
          <h1 style="margin-top: 30px; margin-left: 5px"> Busca de Parentes </h1>
          <v-spacer></v-spacer>
        </v-flex>
        <v-flex>
            <v-text-field
            append-icon="search"
            single-line
            hide-details
            v-model="search"
        ></v-text-field>
        </v-flex>
      </v-layout>
      <v-card-text>
        <v-container>
          <v-layout row>
              <v-flex xs-8>
                 <v-data-table
                  :headers="headers"
                  :items="rows"
                  :search="search"
                  >
                  <template slot="items" slot-scope="props">
                    <td @click="abrir(props.item)">
                        <v-avatar :tile="true"
                        size="60">
                        <img class= "img-thumbnail img-search" :src="props.item.image" />
                        </v-avatar>
                        </td>
                    <td @click="abrir(props.item)">{{ props.item.username }}</td>
                    <td @click="abrir(props.item)">{{ props.item.email }}</td>
                    <td @click="abrir(props.item)">{{ props.item.name }}</td>
                  </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      Sua busca por "{{ search }}" não encontrou resultados.
                  </v-alert>
                  </v-data-table>
              </v-flex>
              <v-dialog
                v-model="info"
                width="600"
                persistent
                transition="dialog-bottom-transition"
              >
                <v-card
                hover
                tile>
                  <v-card-title>
                    <v-flex xs6>
                      <v-avatar :tile="true"
                        size="220">
                        <img class= "img-thumbnail img-search" :src="dados.image" />
                      </v-avatar>
                    </v-flex>
                    <v-flex xs6>
                      <v-form v-model="valid" ref="form" lazy-validation >
                        <v-text-field
                          label="*Grau de Parentesco"
                          hint="Pai/Mãe/Tio"
                          persistent-hint
                          :rules="[v => !!v || 'Parentesco é obrigatório']"
                          required
                          v-model="parentesco"
                        ></v-text-field>
                        <v-text-field
                          label="CPF"
                          mask="###.###.###-##"
                          hint="Obrigatório se for responsável financeiro"
                          persistent-hint
                          v-model="cpf"
                        ></v-text-field>
                        <v-checkbox
                          v-model="financeiro"
                          label="É o responsável financeiro?"
                          required
                        ></v-checkbox>
                        <v-btn color="primary"  @click.native="salvar" >Salvar</v-btn>
                        <v-btn color="primary"  @click.native="info = false" >Cancelar</v-btn>
                      </v-form>
                    </v-flex>
                  </v-card-title>
                </v-card>
              </v-dialog>

          </v-layout>
        </v-container>
        <v-snackbar
          v-model="snackbar"
          bottom
          color="red"
        >
           CPF é obrigatório. 
        </v-snackbar>


      </v-card-text>
  </v-card>
</template>

<script>
import api from '@/api'
export default {
  components: {
  },
  props: {
  },
  data () {
    return {
      parente: [],
      search: '',
      snackbar: false,
      info: false,
      financeiro: false,
      familia: {
        parente: {}
      },
      cont: -1,
      cpf: '',
      parentesco: '',
      valid: true,
      dados: {},
      headers: [
        { text: 'Imagem', sortable: false, value: 'image' },
        { text: 'Nome de usuário', value: 'username' },
        { text: 'Email', value: 'email' },
        { text: 'Nome', value: 'name' }
      ],
      rows: []
    }
  },
  mounted () {
    api.request('GET', 'search-user?groups__name=Parente').then((response) => {
      var arr = response.data.map(function (data, index) {
        return {
          image: data.profilePic,
          email: data.email,
          username: data.username,
          name: data.first_name,
          id: data.id,
          last_name: data.last_name,
          unidade: data.unidade,
          cpf: data.cpf
        }
      })
      this.rows = arr
      console.log(arr)
    })
  },
  methods: {
    abrir (parenteDado) {
      this.dados = parenteDado
      this.familia = { 'parente': {
        'username': parenteDado.username,
        'cpf': '',
        'first_name': parenteDado.name,
        'last_name': parenteDado.last_name,
        'id': parenteDado.id,
        'unidade': parenteDado.unidade,
        'email': parenteDado.email
      },
        'parentesco': '',
        'respfinanceiro': false,
        'cantEdit': true
      }
      this.info = true
    },
    salvar () {
      if (this.$refs.form.validate()) {
        this.familia.respfinanceiro = this.financeiro
        this.familia.parente.cpf = this.cpf
        this.familia.parentesco = this.parentesco
        if (this.financeiro === false) {
          this.$emit('existente', this.familia)
          this.info = false
          this.parentesco = ''
          this.cpf = ''
          this.familia = {}
          this.$emit('close')
        } else {
          if (this.cpf === '') {
            this.snackbar = true
          } else {
            this.$emit('existente', this.familia)
            this.info = false
            this.financeiro = false
            this.parentesco = ''
            this.cpf = ''
            this.familia = {}
            this.$emit('close')
          }
        }
      }
    }
  }
}
</script>
<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/reusable/DialogParente.vue